import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDocumentationCardItem } from '../../../../reducers/documentation/documentationCardReducer';
import { useExpandedMode } from '../../../pages/configuration-canvas/panels-reserve-space/useExpandedMode';
import { DocumentationCard } from '../../salesforce-documentation-card/DocumentationCard';
import { useDocumentationCard } from '../documentation-card/useDocumentationCard';
import { SalesforceItem } from '../../../parser/ConfigurationItemTypes';

export const DocumentationCardRenderer = ({
  crmOrgId,
  onCloseDocumentationDialog,
}: {
  crmOrgId: string;
  onCloseDocumentationDialog?: () => void;
}) => {
  const { handleCloseCard } = useDocumentationCard();

  const selectedCardItem = useSelector(selectDocumentationCardItem);
  const platform = selectedCardItem?.platform;
  const configurationItem = selectedCardItem?.item;
  const { isExpandedMode } = useExpandedMode();

  useEffect(() => {
    return () => {
      handleCloseCard();
    };
  }, [handleCloseCard]);

  if (!configurationItem) return null;

  if (platform === 'salesforce') {
    return (
      <DocumentationCard
        configurationItem={configurationItem as SalesforceItem}
        type={configurationItem?.parentType}
        crmOrgId={crmOrgId}
        staticView={!!isExpandedMode}
        onCloseDocumentationDialog={onCloseDocumentationDialog}
      />
    );
  }

  if (platform === 'snowflake') {
    return <></>;
  }
};
